function normalizeQuery(query) {
    return query === undefined ? '' : query;
}

function requireDataList(response, entityName) {
    if (response.data.errorCode !== 0) {
        throw new Error(entityName + ' search failed');
    }
    return Array.isArray(response.data.dataList) ? response.data.dataList : [];
}

function requireCompanyUUID(companyUUID) {
    if (companyUUID == null || companyUUID === '') {
        throw new Error('Document catalog companyUUID is required');
    }
}

export async function searchDocumentClients(axios, query, companyUUID) {
    requireCompanyUUID(companyUUID);
    const response = await axios.post('query_user_client_user_web', {
        params: {
            delStatus: 0,
            currentPage: 1,
            pageSize: 50,
            userWebCommonQuery: normalizeQuery(query),
            orderName: 'name',
            orderTpe: 1,
            companyUUID
        }
    });
    return requireDataList(response, 'Client')
        .filter(client => client != null
            && (client.companyUUID == null || client.companyUUID === companyUUID)
            && Number(client.isDelete) !== 1 && Number(client.syncStatus) !== 1)
        .map(client => Object.assign({}, client, {value: client.name == null ? '' : client.name}));
}

export async function searchDocumentItems(axios, query, companyUUID) {
    requireCompanyUUID(companyUUID);
    const response = await axios.post('query_item_list_user_web', {
        params: {
            delStatus: 0,
            currentPage: 1,
            pageSize: 50,
            userWebCommonQuery: normalizeQuery(query),
            orderName: 'itemDescription',
            orderTpe: 1,
            companyUUID
        }
    });
    return requireDataList(response, 'Item')
        .filter(item => item != null
            && (item.companyUUID == null || item.companyUUID === companyUUID)
            && Number(item.syncStatus) !== 1)
        .map(item => Object.assign({}, item, {
            value: item.itemDescription == null ? '' : item.itemDescription
        }));
}
